import { render, staticRenderFns } from "./ReplicationSimple.vue?vue&type=template&id=222624a4"
import script from "./ReplicationSimple.vue?vue&type=script&lang=js"
export * from "./ReplicationSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports